import path from 'node:path'
import type { BaseScaffoldOptions } from '@cli-types/next-adapter/init.js'
import { CONFIG_FILE_NAME } from '@cli-constants/paths.js'
import { ensureDir, safeWriteFile } from '@cli-utils/files.js'
import { serializeConfig } from '@core-engine/config/serialize/serialize-config.js'
export function scaffoldBase({
  cwd,
  config,
  includeEmailTemplatesDir = false
}: BaseScaffoldOptions): string[] {
  const created: string[] = []

  const adminDirs = [
    config.paths.admin,
    config.paths.schemas,
    path.join(config.paths.admin, 'lib'),
    path.join(config.paths.admin, 'lib', 'db'),
    path.join(config.paths.admin, 'lib', 'db', 'core'),
    path.join(config.paths.admin, 'lib', 'db', 'migrations'),
    path.join(config.paths.admin, 'lib', 'actions'),
    path.join(config.paths.admin, 'lib', 'actions', 'auth'),
    path.join(config.paths.admin, 'lib', 'actions', 'email'),
    path.join(config.paths.admin, 'lib', 'actions', 'forms'),
    path.join(config.paths.admin, 'lib', 'actions', 'media'),
    path.join(config.paths.admin, 'lib', 'actions', 'profile'),
    path.join(config.paths.admin, 'lib', 'actions', 'storage'),
    path.join(config.paths.admin, 'lib', 'actions', 'upload'),
    path.join(config.paths.admin, 'lib', 'actions', 'users'),
    path.join(config.paths.admin, 'hooks'),
    path.join(config.paths.admin, 'components', 'ui'),
    path.join(config.paths.admin, 'components', 'custom'),
    path.join(config.paths.admin, 'components', 'layouts'),
    path.join(config.paths.admin, 'components', 'shared'),
    path.join(config.paths.admin, 'components', 'shared', 'data-table'),
    path.join(config.paths.admin, 'components', 'shared', 'media'),
    path.join(config.paths.admin, 'data'),
    path.join(config.paths.admin, 'data', 'navigation'),
    path.join(config.paths.admin, 'types'),
    path.join(config.paths.admin, 'utils'),
    path.join(config.paths.admin, 'utils', 'core')
  ]

  if (includeEmailTemplatesDir) {
    adminDirs.push(path.join(config.paths.admin, 'components', 'email-templates'))
  }

  for (const dir of adminDirs) {
    ensureDir(path.resolve(cwd, dir))
  }

  const adminDir = path.dirname(config.paths.pages)
  const appDirs = [
    config.paths.pages,
    config.paths.login,
    config.paths.api,
    path.join(adminDir, '(account)', 'profile')
  ]

  for (const dir of appDirs) {
    ensureDir(path.resolve(cwd, dir))
  }

  const configContent = serializeConfig(config)
  if (safeWriteFile(path.resolve(cwd, CONFIG_FILE_NAME), configContent)) {
    created.push(CONFIG_FILE_NAME)
  }

  return created
}
